import Box from "@mui/material/Box";

import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Radio, Switch } from "@mui/material";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { useEffect, useState } from "react";
import {
  Availability,
  AvailabilityType,
} from "src/model_types/commonTypes.types";
import { backgroundColor } from "src/styles/mainstyle";
import { useRef } from "react";
interface AvailabilityProps {
  availabilityData?: Availability;
  setAvailabilityData: (availabilityData: Availability) => void;
}

export default function AvailabilitySelector({
  availabilityData,
  setAvailabilityData,
}: AvailabilityProps) {
  const [availabilityDays, setavailabilityDays] = useState<
    (DateObject | null)[]
  >([]);
  const datePickerRef = useRef<any>(null);
  useEffect(() => {
    if (availabilityData?.type === "selected_days" && datePickerRef.current) {
      datePickerRef.current.openCalendar();
    }
  }, [availabilityData?.type]);
  useEffect(() => {
    if (availabilityDays && availabilityDays.length > 0) {
      const datesArray = (availabilityDays as any).map((dates: DateObject[]) =>
        dates.map(
          (date) =>
            new Date(
              Number(date.year),
              Number(date.month) - 1,
              Number(date.day),
            ),
        ),
      );
      setAvailabilityData({
        ...availabilityData,
        days: datesArray,
      });
    }
  }, [availabilityDays]);
  return (
    <>
      <FormControl component="fieldset">
        <RadioGroup
          aria-label="availability"
          name="availability"
          value={availabilityData?.type}
          onChange={(e) =>
            setAvailabilityData({
              type: e.target.value as AvailabilityType,
            })
          }
          row
        >
          <FormControlLabel
            value="anytime"
            control={
              <Radio
                sx={{
                  color: backgroundColor,
                  "&.Mui-checked": { color: backgroundColor },
                }}
              />
            }
            label="Anytime"
          />
          <FormControlLabel
            value="student"
            control={
              <Radio
                sx={{
                  color: backgroundColor,
                  "&.Mui-checked": { color: backgroundColor },
                }}
              />
            }
            label="Student"
          />
          <FormControlLabel
            value="selected_days"
            control={
              <Radio
                sx={{
                  color: backgroundColor,
                  "&.Mui-checked": { color: backgroundColor },
                }}
              />
            }
            label="Selected days"
          />
        </RadioGroup>
      </FormControl>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {availabilityData?.type === "selected_days" && (
          <Box>
            <DatePicker
              style={{
                width: "200%",
              }}
              value={availabilityData?.days as any}
              onChange={(dates) => {
                const datesArray = Array.isArray(dates)
                  ? dates
                  : [dates, dates];
                return setavailabilityDays(datesArray);
              }}
              ref={datePickerRef}
              multiple
              range
            />
          </Box>
        )}
      </Box>
      {availabilityData?.type === "student" && (
        <>
          <FormControlLabel
            control={
              <Switch
                checked={availabilityData?.student?.fallAndWinter}
                onChange={() => {
                  setAvailabilityData({
                    ...availabilityData,
                    student: {
                      ...availabilityData?.student,
                      fallAndWinter: !availabilityData?.student?.fallAndWinter,
                    },
                  });
                }}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: backgroundColor, // thumb color when checked
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: backgroundColor, // track color when checked
                  },
                }}
              />
            }
            label={"Fall/Winter " + new Date().getFullYear()}
          />
          <FormControlLabel
            control={
              <Switch
                checked={availabilityData.student?.springAndSummer}
                onChange={() => {
                  setAvailabilityData({
                    ...availabilityData,
                    student: {
                      ...availabilityData?.student,
                      springAndSummer:
                        !availabilityData?.student?.springAndSummer,
                    },
                  });
                }}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: backgroundColor, // thumb color when checked
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: backgroundColor, // track color when checked
                  },
                }}
              />
            }
            label={"Spring/Summer " + (new Date().getFullYear() + 1)}
          />
          <FormControlLabel
            control={
              <Switch
                checked={availabilityData.student?.fullYear}
                onChange={() => {
                  setAvailabilityData({
                    ...availabilityData,
                    student: {
                      ...availabilityData?.student,
                      fullYear: !availabilityData?.student?.fullYear,
                    },
                  });
                }}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: backgroundColor, // thumb color when checked
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: backgroundColor, // track color when checked
                  },
                }}
              />
            }
            label="Full Year"
          />
        </>
      )}
    </>
  );
}
